export default __webpack_public_path__ + "static/media/visa.01eed528.svg";